import { render, staticRenderFns } from "./Backdate.vue?vue&type=template&id=788ab000&"
import script from "./Backdate.vue?vue&type=script&lang=js&"
export * from "./Backdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports